import { doGet, toUrl } from "./lib.js";
export async function getEventByIdentifier(clientInfo, input) {
  const url = toUrl(clientInfo.orgId, `events/${input.identifier}`);
  return await doGet(url, clientInfo);
}
